export default __webpack_public_path__ + "static/media/book_5.5f06618c.svg";